<template>
    <transition name="fade">

    <div class="app-message" :class="getClass">
        <p v-html="text"></p>
        <span title="Закрыть" class="js-close-message" @click="$emit('close')">
            <icon-base width="14" height="14" viewBox="0 0 14 14" icon-name="Закрыть"><icon-close fill="#A6AAB4"/></icon-base>
        </span>
        <div class="bg-icon">
            <icon-base width="20" height="20" viewBox="0 0 20 20"><component :is="getIcon"/></icon-base>
        </div>
    </div>
    </transition>
</template>

<script>
    import IconBase from "./common/IconBase";
    import IconClose from "./common/icons/IconClose";
    import IconInfo from "./common/icons/IconInfo";
    import IconAlert from "./common/icons/IconAlert";
    import IconError from "./common/icons/IconError";
    import IconSuccess from "./common/icons/IconSuccess";
    import {NOTIFICATION_WARNING, NOTIFICATION_DANGER, NOTIFICATION_INFO, NOTIFICATION_SUCCESS} from "../constants/common";

    export default {
        name: 'notification',
        components: {
            IconSuccess,
            IconError,
            IconAlert,
            IconInfo,
            IconClose,
            IconBase,
        },
        props: {
            text: String,
            type: {
                type: String,
                default: NOTIFICATION_INFO
            },
            time: {
                type: Number,
                default: 3000
            }
        },
        computed: {
            getClass() {
                switch(this.type) {
                    case NOTIFICATION_INFO:
                        return 'info-view';
                    case NOTIFICATION_SUCCESS:
                        return '';
                    case NOTIFICATION_DANGER:
                        return 'error-view';
                    case NOTIFICATION_WARNING:
                        return 'alert-view';
                    default:
                        return 'info-view'
                }
            },
            getIcon() {
                switch(this.type) {
                    case NOTIFICATION_INFO:
                        return IconInfo;
                    case NOTIFICATION_SUCCESS:
                        return IconSuccess;
                    case NOTIFICATION_DANGER:
                        return IconError;
                    case NOTIFICATION_WARNING:
                        return IconAlert;
                    default:
                        return IconInfo
                }
            }
        },
        mounted() {
            setTimeout(() => {
                this.$emit('close');
            }, this.time)
        }
    }
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
        opacity: 0;
    }

</style>
